import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const PDFModal = ({ isOpen, onClose, pdfUrl, title }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className="
          max-w-[90vw]
          w-[90vw]
          h-[90vh]
          p-0
          flex
          flex-col
        "
      >
        <DialogHeader className="px-6 py-4 border-b">
          <DialogTitle className="text-lg font-semibold">{title}</DialogTitle>
        </DialogHeader>

        <div className="flex-1 overflow-hidden">
          {pdfUrl && (
            <iframe
              src={pdfUrl}
              title="PDF Preview"
              className="w-full h-full border-0"
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PDFModal;
